/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ shown: NonNullable<unknown>, total: NonNullable<unknown> }} Admin_Export_Customers_TruncatedInputs */



/**
* | output |
* | --- |
* | "Only the first {shown} of {total} customers are listed. Leave all customers ticked to export every one of them." |
*
* @param {Admin_Export_Customers_TruncatedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_export_customers_truncated = /** @type {((inputs: Admin_Export_Customers_TruncatedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Export_Customers_TruncatedInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Nur die ersten ${i?.shown} von ${i?.total} Kunden werden angezeigt. Lassen Sie alle Kunden ausgewählt, um jeden davon zu exportieren.`)
	return /** @type {LocalizedString} */ (`Only the first ${i?.shown} of ${i?.total} customers are listed. Leave all customers ticked to export every one of them.`)
});